import { TaskDefinitionFragment } from "../../../graphql";
import { CandidateRediscoveryConfiguration } from "./types";

export const parseCandidateRediscoveryConfiguration = (
  taskDefinition: TaskDefinitionFragment | null
): CandidateRediscoveryConfiguration | null => {
  if (!taskDefinition) {
    return null;
  }
  try {
    const c = JSON.parse(taskDefinition.configuration);
    return {
      customInstructions: c.custom_instructions || "",
    };
  } catch (e) {
    return null;
  }
};

export const stringifyCandidateRediscoveryConfiguration = (
  configuration?: CandidateRediscoveryConfiguration
): string => {
  return JSON.stringify({
    // eslint-disable-next-line camelcase
    custom_instructions: configuration?.customInstructions || "",
  });
};
